<div class="main-column">
    <app-hub-nav-header
        *ngIf="savedCategory"
		[sportCode]="savedCategory"
		currentRoute="news"
		[overrideTitle]="title"
	></app-hub-nav-header>

    <ng-container *ngIf="!savedCategory">
        <xng-breadcrumb separator=">"></xng-breadcrumb>
    </ng-container>
    <!-- <div class="all-title">
        <h1 class="title">
            {{ title }}
        </h1>
    </div> -->

    <!-- <div class="all-title" *ngIf="!savedCategory">
        <h1 class="title">
            Sports Betting News
        </h1>
    </div> -->

    <div class="page-description" >
		<h1 class="page-title">{{title}} </h1>
		<app-page-intro-copy *ngIf="trustedDesc" [html]="trustedDesc"></app-page-intro-copy>
	</div>
	<app-swc-preview-banner *ngIf="(savedCategory | uppercase) === 'SWC'"></app-swc-preview-banner>
    <!-- <app-find
        class="small-only"
        [(searchQuery)]="searchQuery"
        [(savedQuery)]="savedQuery"
        [(selectedAuthor)]="selectedAuthor"
        [(selectedCategory)]="selectedCategory"
        [blogLoading]="blogLoading"
    ></app-find> -->
	<app-article-list
        [category]="selectedCategory"
        [author]="selectedAuthor"
        [query]="savedQuery"
        [(blogLoading)]="blogLoading"
        [currentPage]="pageNumber"
        [nextPageURL]="nextPageURL"
    ></app-article-list>
    <app-best-offers [sportCode]="savedCategory" *ngIf="environment.optionalFeatures.includes('best-offers')"></app-best-offers>
	<app-display-ad type="main-column" *ngIf="(environment.googleAdsConfig?.adSpaces?.['main-column'] || environment.optionalFeatures.includes('placeholder-ads')) && trustedCopy" class="main-column-padding" [sportCode]="savedCategory"></app-display-ad>
    <div class="description" *ngIf="trustedCopy" [innerHTML]="trustedCopy"></div>
</div>
<div class="sidebar">
    <!-- <app-find
        class="large-only"
        [(searchQuery)]="searchQuery"
        [(savedQuery)]="savedQuery"
        [(selectedAuthor)]="selectedAuthor"
        [(selectedCategory)]="selectedCategory"
        [blogLoading]="blogLoading"
    >
    </app-find> -->
    <app-display-ad type="articles-POS1" class="large-only" [largeOnly]="true" *ngIf="selectedCategory !== 'racing' && (environment.googleAdsConfig?.adSpaces?.['articles-POS1'] || environment.optionalFeatures.includes('placeholder-ads'))"></app-display-ad>
		
    <app-display-ad type="horseracing-POS1" class="large-only" [largeOnly]="true" *ngIf="selectedCategory ==='racing' && (environment.googleAdsConfig?.adSpaces?.['horseracing-POS1'] || environment.optionalFeatures.includes('placeholder-ads'))"></app-display-ad>
	

    <ng-container *ngIf="selectedCategory ==='racing' && environment.siteTitle === 'Stats Insider' ; else upcoming">
        <app-latest-articles-list [sportCode]="selectedCategory"></app-latest-articles-list>
    </ng-container>
    <ng-template  #upcoming>
        <app-upcoming-matches-list
        *ngIf="environment.availableSports.length > 0 && (!savedCategory || isValidActiveSport(savedCategory))"
        [sportCode]="savedCategory || undefined"
    ></app-upcoming-matches-list>
    </ng-template>
    <app-book-offers *ngIf="environment.optionalFeatures.includes('welcome-offers')"></app-book-offers>
    <app-legal-betting *ngIf="environment.optionalFeatures.includes('legal-betting-sidebar')"></app-legal-betting>
    <app-radar-link *ngIf="environment.siteTitle === 'Radar Sports'"></app-radar-link>
    <!-- <app-how-we-make-money *ngIf="environment.optionalFeatures.includes('best-books')"></app-how-we-make-money> -->
    <app-newsletter-signup-prompt *ngIf="environment.optionalFeatures.includes('newsletter')"></app-newsletter-signup-prompt>
	<app-display-ad type="sidebar-multi" *ngIf="environment.googleAdsConfig?.adSpaces?.['sidebar-multi'] || environment.optionalFeatures.includes('placeholder-ads')" [sportCode]="savedCategory"></app-display-ad>
    <app-display-ad type="articles-POS2" class="large-only sticky" [largeOnly]="true" *ngIf="selectedCategory !== 'racing' && (environment.googleAdsConfig?.adSpaces?.['articles-POS2'] || environment.optionalFeatures.includes('placeholder-ads'))"></app-display-ad>
	<app-display-ad type="horseracing-POS2" class="large-only sticky" [largeOnly]="true" *ngIf="selectedCategory ==='racing' && (environment.googleAdsConfig?.adSpaces?.['horseracing-POS2'] || environment.optionalFeatures.includes('placeholder-ads'))"></app-display-ad>
    <app-odds-disclaimer *ngIf="environment.optionalFeatures.includes('odds-disclaimer')"></app-odds-disclaimer>
	
</div>
<!-- <app-adhesive-banner *ngIf="environment.optionalFeatures.includes('adhesive-banner')"></app-adhesive-banner> -->
<app-subscribe-scroll-prompt *ngIf="environment.optionalFeatures.includes('newsletter') && environment.newsletterProvider === 'surge'"></app-subscribe-scroll-prompt>
